<template src="./SelectCustomWithSearch.html"></template>

<script>
import {nextTick, ref, watch} from "vue";
import { onClickOutside } from '@vueuse/core'
export default {
  name: 'SelectCustomWithSearch',
  props: {
    options: {
      type: Object,
      required: true,
    },
    listCompanies: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    valueDefault: {
      type: String,
      required: false,
      default: () => ''
    },
    placeholder: {
      type: String,
      required: false,
      default: () => ''
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false
    },
    errorText: {
      type: String,
      required: false,
      default: () => ''
    },
    isError: {
      type: Boolean,
      required: false,
      default: () => false
    },
  },
  emits: ['action'],
  setup(props, {emit}) {
    const customSelectActive = ref('');
    const ariaExpandedBtn = ref(false);
    const modalRef = ref(null)
    const isChoosed = ref(false)
    const distanceWithLabel =  ref('0px')
    const labelForm = ref(null)
    const error = ref(props.errorText)
    const valueSelectSearch = ref(props.valueDefault)
    const valueSelectMatch = ref([])
    const label_val = ref(props.label)
    const id_val = ref(props.id)
    const placeholder_val = ref(props.placeholder)
    const valueDefault_val = ref(props.valueDefault)
    const required_val = ref(props.required)
    const options_val = ref([])

    function showOption() {
      customSelectActive.value = customSelectActive.value === '' ? 'active' : ''
      ariaExpandedBtn.value = !ariaExpandedBtn.value
    }

    onClickOutside(modalRef, () => {
      customSelectActive.value = ''
      },
    )

    watch(() => props.valueDefault, (newVal) => {
      valueSelectSearch.value = newVal
    })

    watch(
        () => props.errorText,
        async (newError) => {
          error.value = newError
          await nextTick()
          distanceWithLabel.value =
              (labelForm.value?.offsetWidth || 0) + 10 + 'px'
        }
    )

    watch(() => valueSelectSearch.value, (newValue) => {
      if(!isChoosed.value) {
        customSelectActive.value = 'active'
        valueSelectMatch.value = props.listCompanies.filter((company) => company.company_name.includes(newValue))
        options_val.value = []
        valueSelectMatch.value.forEach((company) => {
          options_val.value.push({
            name: company.company_name,
            value: company.id,
          })
        })
        if(options_val.value.length === 0) {
          customSelectActive.value = ''
        }
        emit('action', newValue);
      }
      isChoosed.value = false
    })

    function chooseOption(key, name) {
      isChoosed.value = true
      valueSelectSearch.value = name
      customSelectActive.value = ''
      emit('action', key);
    }

    return {
      label_val,
      id_val,
      placeholder_val,
      valueDefault_val,
      required_val,
      options_val,
      customSelectActive,
      ariaExpandedBtn,
      modalRef,
      valueSelectSearch,
      distanceWithLabel,
      labelForm,
      showOption,
      chooseOption,
    }
  }
}
</script>

<style lang="scss">
.custom-select-search {
  position: relative;
  max-width: 100%;
  font-size: 1rem;
  color: #000;
  .arrow {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #000;
    transition: transform ease-in-out 0.3s;
    position: absolute;
    right: 10px;
    top: 70%;
  }
}

.select-button {
  width: 100%;
  font-size: 1rem;
  background-color: #fff;
  padding: 0.3em 1em;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selected-value {
  text-align: left;
}

.select-dropdown {
  position: absolute;
  list-style: none;
  width: 100%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 4px;
  padding: 5px 10px;
  margin-top: 5px;
  max-height: 200px;
  overflow-y: auto;
  transition: 0.5s ease;
  transform: scaleY(0);
  opacity: 0;
  visibility: hidden;
}

.select-dropdown:focus-within {
  box-shadow: 0 10px 25px rgba(94, 108, 233, 0.6);
}

.select-dropdown li {
  position: relative;
  cursor: pointer;
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 0 5px;
}

.select-dropdown li label {
  width: 100%;
  padding: 8px 10px;
  cursor: pointer;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.select-dropdown::-webkit-scrollbar {
  width: 7px;
}
.select-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 25px;
}

.select-dropdown::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 25px;
}

.select-dropdown li:hover,
.select-dropdown input:checked ~ label {
  background-color: #f2f2f2;
}

.select-dropdown input:focus ~ label {
  background-color: #dfdfdf;
}

.select-dropdown input[type="radio"] {
  position: absolute;
  left: 0;
  opacity: 0;
}

/* interactivity */

.custom-select-search.active .arrow {
  transform: rotate(180deg);
}

.custom-select-search.active .select-dropdown {
  opacity: 1;
  visibility: visible;
  transform: scaleY(1);
  z-index: 100;
}
</style>
